// extracted by mini-css-extract-plugin
export default {"section":"EmailWarning_section__jKLay","button":"EmailWarning_button__TzDYv","bold":"EmailWarning_bold__PqUW5","red":"EmailWarning_red__UM3FQ"};